export const fileDownload = (data: Blob | any, fileName: string) => {
  // const url = window.URL.createObjectURL(new Blob([data]));
  // const link = document.createElement("a");
  // link.href = url;
  // link.setAttribute("download", fileName);
  // document.body.appendChild(link);
  // link.click();
  // link.remove();

  // D드라이브에서 C 드라이브로 이동 다운
  const link = document.createElement("a");
  link.href = `${process.env.REACT_APP_API_HOST}/files/download?filename=${fileName}`;
  link.download = fileName;
  link.click();
  link.remove();
};
